import { createSelector } from 'reselect';

const selectNotification = (state) => state.get('notification');

const makeSelectNotificationMessageType = () =>
  createSelector(selectNotification, (state) => state.get('messageType'));

const makeSelectNotificationMessage = () =>
  createSelector(selectNotification, (state) => state.get('message'));

const makeSelectNotificationVisibility = () =>
  createSelector(selectNotification, (state) => state.get('show'));

export {
    makeSelectNotificationMessageType,
    makeSelectNotificationMessage,
    makeSelectNotificationVisibility,
};



// WEBPACK FOOTER //
// ./app/containers/Toastr/selectors.js